<template>
  <div class="wrap default">
    <transition name="fade" mode="out-in" appear>
      <LoadingAnimation v-if="loading" />
      <div class="default_center" v-else>
        <transition name="fade" mode="out-in" appear>
          <slot></slot>
        </transition>
      </div>
      <!-- <Plug v-else-if="!loading && Array.isArray(items) ? !items.length : !items" /> -->
    </transition>
  </div>
</template>

<script>
// import Plug from 'components/Plug'
import LoadingAnimation from 'components/LoadingAnimation'

export default {
  name: 'TemplatePage',
  props: {
    loading: Boolean,
    items: [Object, Array],
    content_only: Boolean,
  },
  components: {
    // Plug,
    LoadingAnimation,
  },
}
</script>

<style lang="scss" scoped>
.default {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
}
</style>
